import React, { useState, Fragment } from "react";
import Button from "../../common/Buttons/Button/Button";
import ButtonLink from "../../common/Buttons/ButtonLink/ButtonLink";
import Flyout from "../../common/Modals/Flyout/Flyout";
import NotificationList, { Notification } from "../NotificationList/NotificationList";

const notificationTestData = [
    {
        status: "error",
        title: "Pest Detected",
        description: "Flies detected at Manchester Sedgley Park (Convenience)",
        date: "10 Oct 2022",
        href: "/dashboard",
    },
    {
        status: "info",
        title: "Pest Detected",
        description: "Flies detected at Manchester Sedgley Park (Convenience)",
        date: "10 Oct 2022",
        href: "/dashboard",
    },
    {
        status: "error",
        title: "Pest Detected",
        description: "Flies detected at Manchester Sedgley Park (Convenience)",
        date: "10 Oct 2022",
        href: "/dashboard",
    },
    {
        status: "error",
        title: "Pest Detected",
        description: "Flies detected at Manchester Sedgley Park (Convenience)",
        date: "10 Oct 2022",
        href: "/dashboard",
    },

    {
        status: "success",
        title: "Visit Completed",
        description: "Visit completed at Manchester Sedgley Park (Convenience)",
        date: "10 Oct 2022",
        href: "/dashboard",
    },

    {
        status: "info",
        title: "Vergo Hub maintenance",
        description: "We'll be down for maintenance at 13:00 - 15:00",
        date: "30 Sep 2022",
        href: "/dashboard",
    },

    {
        status: "warning",
        title: "Rats detected",
        description: "Rats detected at Birkenhead (Main) 0717",
        date: "19 Sep 2022",
        href: "/dashboard",
    },
    {
        status: "warning",
        title: "Rats detected",
        description: "Rats detected at Birkenhead (Main) 0717",
        date: "19 Sep 2022",
        href: "/dashboard",
    },
    {
        status: "warning",
        title: "Rats detected",
        description: "Rats detected at Birkenhead (Main) 0717",
        date: "19 Sep 2022",
        href: "/dashboard",
    },
] as Notification[];

interface Props {
    children?: GenericModalChildren;
}

const NotificationFlyout = ({ children }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleFlyout = () => {
        setIsOpen((state) => !state);
    };

    return (
        <Fragment>
            <Flyout.Trigger onClick={toggleFlyout}>{children}</Flyout.Trigger>

            <Flyout isOpen={isOpen} onClose={toggleFlyout}>
                <Flyout.Header onClose={toggleFlyout}>Notifications</Flyout.Header>
                <Flyout.Content>
                    <NotificationList items={notificationTestData} />
                </Flyout.Content>
                <Flyout.Actions after className="justify-between">
                    <ButtonLink variant="secondary" href="/notifications">
                        View All
                    </ButtonLink>
                    <Button variant="borderedMint">Mark all as read</Button>
                </Flyout.Actions>
            </Flyout>
        </Fragment>
    );
};

export default NotificationFlyout;
